
$(document).ready(() => {
    const is_safari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
    const form = $('#registrationForm');
    const input = $('input');
    const button = $('#submitRegistration');

    function removeErrors() {
        form
            .find('div.error-text')
            .remove();
    }

    function IsEmail(email) {
        const regex = /^([a-zA-Z0-9_\.\-\+])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/;
        return regex.test(email);
    }

    function selectCheckbox(obj) {
        const input = $(obj)
            .find('input[type=checkbox]');
        input
            .prop('checked', (!input.prop('checked')));
    }

    if (is_safari) {
        button.on('click', e => {
            button.spinner('start');
            e.preventDefault();
            setTimeout(function () {
                $('<input>').attr({
                    type: 'hidden',
                    id: 'submitRegistration',
                    name: 'submitRegistration'
                }).appendTo('form');
                form.submit();
            }, 125);
        });
    }

    grecaptcha.ready(function() {
        grecaptcha.execute('6Lfs7vsgAAAAAHOI4NWbIkt3sZFqNMV5-9NG9r0T', {action: 'submit'}).then(function(token) {
            $('#googlerecaptcha').val(token);
        });
    });


    form.on('submit', e => {

        button.spinner('start');
        removeErrors();
        const email = $('#email').val();
        const password = $('#password').val();
        const passwordRepeat = $('#passwordRepeat').val();
        const tos = $('#tos').prop('checked');
        const error = [];

        if (email.length === 0) {
            error.unshift({
                type: 'email',
                message: `<div class="error-text email">${emailRequired}</div>`
            });
        } else if (IsEmail(email) === false) {
            error.unshift({
                type: 'email',
                message: `<div class="error-text email">${emailInvalid}</div>`
            });
        }

        if (password.length === 0) {
            error.unshift({
                type: 'password',
                message: `<div class="error-text password">${passwordRequired}</div>`
            });
        }
        if (passwordRepeat.length === 0) {
            error.unshift({
                type: 'passwordRepeat',
                message: `<div class="error-text passwordRepeat">${passwordRepeatRequired}</div>`
            });
        }

        if (tos === false) {
            error.unshift({
                type: 'tos',
                message: `<div class="error-text tos">${tosRequired}</div>`
            });
        }

        if (error.length > 0) {
            e.preventDefault();
            setTimeout(() => {
                $.each(error, (key, item) => {
                    if (item.type === 'tos') {
                        form
                            .find(`#${item.type}`)
                            .parent('div')
                            .addClass('error-checkbox')
                            .after(item.message);
                    } else {
                        form
                            .find(`#${item.type}`)
                            .addClass('error')
                            .after(item.message);
                    }
                });
                button.spinner('end');
            }, 100);
        }
    });

    input.on('change', e => {
        const input = $(e.currentTarget);
        if (input.val().length > 0) {
            input
                .addClass('inputFull');
        } else {
            input
                .removeClass('inputFull');
        }
    });

    input.on('focus', e => {
        const input = $(e.currentTarget);
        input.removeClass('error');
        form
            .find(`div.error-text.${input.prop('id')}`)
            .remove();
    });

    $('.checkbox').on('click', e => {
        const div = $(e.currentTarget);
        if (div.children('input').is('#newsletters') === false) {
            div.removeClass('error-checkbox');
            form
                .find('div.error-text.tos')
                .remove();
        }
    });

    $('.input-field.checkbox').on('click', e => {
        if ($(e.target).hasClass('rules-link') === false) {
            selectCheckbox(e.currentTarget);
        }
    });


});



// WEBPACK FOOTER //
// ./assets/js/registration.js